import type { Components, Theme } from '@mui/material';
import { pxToRem } from '../../../utils';
import { gridMargins } from '../gridLayout';

export const gridConfig: Components<Omit<Theme, 'components'>> = {
  MuiGrid: {
    defaultProps: {
      rowSpacing: '0px',
      columnSpacing: {
        xs: pxToRem(gridMargins.xs),
        sm: pxToRem(gridMargins.sm),
        md: pxToRem(gridMargins.md),
        lg: pxToRem(gridMargins.lg),
      },
    },
    styleOverrides: {
      container: ({ theme }) => ({
        '&&': {
          marginRight: pxToRem(gridMargins.xs),
          marginLeft: pxToRem(gridMargins.xs),
          [theme.breakpoints.up('sm')]: {
            marginRight: pxToRem(gridMargins.sm),
            marginLeft: pxToRem(gridMargins.sm),
          },
          [theme.breakpoints.up('md')]: {
            marginRight: pxToRem(gridMargins.md),
            marginLeft: pxToRem(gridMargins.md),
          },
          [theme.breakpoints.up('lg')]: {
            marginRight: pxToRem(gridMargins.lg),
            marginLeft: pxToRem(gridMargins.lg),
          },
        },
      }),
    },
  },
};
